<template>
  <div id="header" class="flex flex-space-between flex-align-items-center">
    <h1 id="header-title">
      <a v-if="back" href="javascript:void(0)" @click="goBack">
        <img id="header-back-btn" :src="require('./../assets/icons/arrow-back.png')" alt="Επιστροφή">
      </a>
      <span v-if="title">{{ title }}</span>
    </h1>

    <ul class="sav-menu">
        <router-link tag="li" to="/">
          <img :src="require('./../assets/icons/overview.png')" alt="">
        </router-link>
        <router-link tag="li" to="/car" :class="{ 'router-link-exact-active': category == 'car' }">
          <img :src="require('./../assets/icons/car.png')" alt="">
        </router-link>
        <router-link tag="li" to="/moto" :class="{ 'router-link-exact-active': category == 'moto' }">
          <img :src="require('./../assets/icons/moto.png')" alt="">
        </router-link>
        <router-link tag="li" to="/house" :class="{ 'router-link-exact-active': category == 'house' }">
          <img :src="require('./../assets/icons/house.png')" alt="">
        </router-link>
        <router-link tag="li" to="/health" :class="{ 'router-link-exact-active': category == 'health' }">
          <img :src="require('./../assets/icons/health.png')" alt="">
        </router-link>
        <router-link tag="li" to="/calendar">
          <img :src="require('./../assets/icons/calendar.png')" alt="">
        </router-link>
        <router-link tag="li" to="/search" >
          <img :src="require('./../assets/icons/search.png')" alt="">
        </router-link>
        <router-link tag="li" to="/new" >
          <img :src="require('./../assets/icons/add.png')" alt="">
        </router-link>
    </ul>
      
  </div>
</template>

<script>
export default {
  props: ['back', 'title', 'category', 'search'],
  data() {
      return {
        name: 'Header',
        searchQuery: "",
        from : localStorage.getItem('SAV_CRM_PREV_ROUTE')
      }
  },
  methods: {
    goBack: function () {
      if (this.$route.name == 'CarCard' || this.$route.name == 'MotoCard' || this.$route.name == 'HouseCard' || this.$route.name == 'HealthCard') {
        if (this.from == 'Overview') {
          this.$router.push("/#" + this.category + "-" + this.$route.params.id);
        } else if (this.from == 'Calendar' || this.from == 'Search') {
           this.$router.go(-1);
        } else {
          this.$router.push("/" + this.category + "#" + this.category + "-" + this.$route.params.id);
        }
      } else {
        this.$router.go(-1);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./../scss/_colors";

#header {
  margin-bottom: 30px;
}

#header-back-btn {
  height: 22px;
}

#header-title {
  font-weight: 500;
  :not(:last-child) {
    margin-right: 15px;
  }
}

.sav-menu {
  li:last-child {
    margin-left: 20px;
    width: auto;
    position: relative;

    &:before {
      display: block;
      content: '';
      position: absolute;
      left: -15px;
      top: 0;
      height: 100%;
      border-left: 1px solid $black;
    }
  }
}
</style>
